import {gql} from 'apollo-angular';
import {StatusFragment} from "../../fragments/Status";

export const GET_PROVIDER_QUIZ_QUESTION = gql`
  query GetQuizQuestionsOpen($companyProfileId: Int!, $providerType: Int!) {
    getQuizQuestionsProvider(profileID: $companyProfileId, providerType: $providerType){
      status {
        ...statusFields
      }
      id,
      text,
      answers {
        id,
        text
      }
      correctAnswer {
        id
      }
    }
  }
  ${StatusFragment}
`;
